import React from "react";

export const Settings = () => {
  return (
    <div>
      <h1 className="text-center">Settings Page</h1>
    </div>
  );
};
